import o from "../isDate/index.mjs";
import t from "../toDate/index.mjs";
import m from "../_lib/requiredArgs/index.mjs";
function u(r) {
  if (m(1, arguments), !o(r) && typeof r != "number")
    return !1;
  var e = t(r);
  return !isNaN(Number(e));
}
export {
  u as default
};
